interface menuType {
    category: string[];
    footer?: string[];
    time?: string[];
    groups: Array<{
        name: string[];
        level: number;
        volume?: string | string[];
        priceLabel?: string[];
        items: Array<{
            name: string[];
            subtitle?: string[];
            allergens?: string[];
            price?: string[];
        }>;
    }>;
}

export const menu = [
    {
        category: ["Menu à la carte", "Menu à la carte"],
        footer: [
            "Veškeré pečivo si pečeme sami.\n\nSeznam alergenů je k dispozici u personálu.",
            "All bread and pastries are baked by us.\n\nThe list of allergens is available from our staff.",
        ],
        groups: [
            {
                name: ["Předkrmy", "Starters"],
                level: 1,
                items: [
                    {
                        name: [
                            "Burrata, pečená rajčata, balsamico, bazalka, bruschetta",
                            "Burrata, roasted tomatoes, balsamic vinegar, basil, bruschetta",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a"],
                        price: ["229"],
                    },
                    {
                        name: [
                            "Carpaccio z červené řepy, kozí sýr, malinové coulis, focaccia",
                            "Beetroot carpaccio, goat cheese, raspberry coulis, focaccia",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "7"],
                        price: ["229"],
                    },
                    {
                        name: [
                            "Selekce sýrů a uzenin, grissini",
                            "Selection of cheeses and cold cuts, grissini",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "7"],
                        price: ["299"],
                    },
                    {
                        name: [
                            "Hovězí carpaccio, uzená majonéza, parmazán, rukola, focaccia",
                            "Beef carpaccio, smoked mayonnaise, parmesan, rocket, focaccia",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["329"],
                    },
                    {
                        name: [
                            "Krevety, máslová omáčka s česnekem, bílým vínem a chilli, focaccia",
                            "Prawns, butter sauce with garlic, white wine and chilli, focaccia",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "2", "7", "12"],
                        price: ["349"],
                    },
                ],
            },
            {
                name: ["Polévky", "Soups"],
                level: 1,
                items: [
                    {
                        name: [
                            "Rajčatová polévka, ricotta",
                            "Tomato soup, ricotta",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["119"],
                    },
                    {
                        name: [
                            "Kuřecí vývar, celestýnské nudle, mrkev, pažitka",
                            "Chicken broth, sliced crêpe noodles, carrot, chives",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["129"],
                    },
                ],
            },
            {
                name: ["Těstoviny", "Pasta"],
                level: 1,
                items: [
                    {
                        name: [
                            "Spaghetti amatriciana",
                            "Spaghetti amatriciana",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["289"],
                    },
                    {
                        name: [
                            "Spaghetti carbonara s guanciale",
                            "Spaghetti carbonara with guanciale",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["289"],
                    },
                    {
                        name: [
                            "Spaghetti aglio olio e peperoncino",
                            "Spaghetti aglio olio e peperoncino",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3"],
                        price: ["219"],
                    },
                    {
                        name: [
                            "Spaghetti aglio olio e peperoncino s hovězí svíčkovou",
                            "Spaghetti aglio olio e peperoncino with beef tenderloin",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3"],
                        price: ["399"],
                    },
                    {
                        name: [
                            "Penne s bazalkovým pestem a burratou",
                            "Penne with basil pesto and burrata",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7", "8a"],
                        price: ["299"],
                    },
                    {
                        name: [
                            "Penne s bazalkovým pestem a kuřecím masem",
                            "Penne with basil pesto and chicken",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7", "8a"],
                        price: ["299"],
                    },
                    {
                        name: [
                            "Fettuccine, krevety, nduja, česnek, rajčatová omáčka, bazalka",
                            "Fettuccine, prawns, nduja, garlic, tomato sauce, basil",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "2", "3", "7"],
                        price: ["399"],
                    },
                    {
                        name: [
                            "Fettuccine s vepřovou panenkou, smetana, parmazán, pažitka",
                            "Fettuccine with pork tenderloin, cream, parmesan, chives",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["289"],
                    },
                    {
                        name: [
                            "Ravioli plněné mortadellou a ricottou, pistácie, parmazán",
                            "Ravioli filled with mortadella and ricotta, pistachios, parmesan",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["299"],
                    },
                ],
            },
            {
                name: ["Risotta", "Risottos"],
                level: 1,
                items: [
                    {
                        name: [
                            "Dýňové risotto s pancettou a lískovými ořechy",
                            "Pumpkin risotto with pancetta and hazelnuts",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["299"],
                    },
                    {
                        name: [
                            "Hřibové risotto",
                            "Porcini mushroom risotto",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["299"],
                    },
                ],
            },
            {
                name: ["Specialita", "Speciality"],
                level: 1,
                items: [
                    {
                        name: [
                            "Telecí řízek na másle, bramborová kaše",
                            "Veal schnitzel fried in butter, mashed potatoes",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1A", "3", "7"],
                        price: ["399"],
                    },
                ],
            },
            {
                name: ["Masa a ryby", "Meat and fish"],
                level: 1,
                items: [
                    {
                        name: [
                            "Steak z hovězí svíčkové s omáčkou ze zeleného pepře a whisky",
                            "Beef tenderloin steak with green peppercorn and whisky sauce",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["599"],
                    },
                    {
                        name: [
                            "Vepřová panenka sous vide se smetanovou omáčkou s bylinkami",
                            "Sous vide pork tenderloin with creamy herb sauce",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["249"],
                    },
                    {
                        name: [
                            "Kuřecí prso s demiglace",
                            "Chicken breast with demi-glace",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["249"],
                    },
                    {
                        name: [
                            "Burger s hovězím trhaným masem, cheddar, nakládaná červená cibule, uzená mayo, batátové hranolky",
                            "Pulled beef burger, cheddar, pickled red onion, smoked mayo, sweet potato fries",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["399"],
                    },
                    {
                        name: [
                            "Pražma královská, beurre blanc",
                            "Gilthead sea bream, beurre blanc",
                        ],
                        subtitle: ["", ""],
                        allergens: ["4", "7"],
                        price: ["469"],
                    },
                ],
            },
            {
                name: ["Přílohy", "Side dishes"],
                level: 1,
                items: [
                    {
                        name: [
                            "Bramborová kaše s přepuštěným máslem",
                            "Mashed potatoes with clarified butter",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Batátové hranolky",
                            "Sweet potato fries",
                        ],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Parmazánové grenaille",
                            "Baby potatoes with parmesan",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Míchaný salát s cherry rajčaty, mrkev, dýňová semínka",
                            "Mixed salad with cherry tomatoes, carrot, pumpkin seeds",
                        ],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grilovaná zelenina s bazalkovým olejem",
                            "Grilled vegetables with basil oil",
                        ],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grilované portobello",
                            "Grilled portobello mushroom",
                        ],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Saláty", "Salads"],
                level: 1,
                items: [
                    {
                        name: [
                            "Salát s gratinovaným kozím sýrem, dýně, hruška, vlašské ořechy",
                            "Salad with gratinated goat cheese, pumpkin, pear, walnuts",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7", "8c"],
                        price: ["329"],
                    },
                    {
                        name: [
                            "Caesar salát, kuřecí maso, pancetta, parmazán, krutony",
                            "Caesar salad, chicken, pancetta, parmesan, croutons",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "4", "7", "10"],
                        price: ["339"],
                    },
                    {
                        name: [
                            "Salát s hovězí svíčkovou, sušená rajčata, parmazánové chipsy, dijon",
                            "Salad with beef tenderloin, sun-dried tomatoes, parmesan crisps, Dijon mustard",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7", "10"],
                        price: ["399"],
                    },
                ],
            },
        ],
    },

    /* {
        category: ["Menu à la carte", "Menu à la carte"],
        groups: [
            {
                name: ["Předkrmy", "Starters"],
                level: 1,
                items: [
                    {
                        name: [
                            "Bruschetta s cherry rajčaty a burratou",
                            "Bruschetta with Cherry Tomatoes and Burrata",
                        ],
                        subtitle: [
                            "cherry rajčata, burrata, bazalkové pesto",
                            "cherry tomatoes, burrata, basil pesto",
                        ],
                        price: ["219"],
                    },

                    {
                        name: [
                            "Hovězí carpaccio, foccacia",
                            "Beef Carpaccio, Focaccia",
                        ],
                        subtitle: [
                            "dijonská majonéza, grana padano, rukola",
                            "Dijon Mayonnaise, Grana Padano, Arugula",
                        ],
                        price: ["319"],
                    },
                    // { name: ["Fritované kalamáry", "Fried Calamari"], subtitle: ["citronová majonéza, petrželka, ciabatta", "Lemon Mayonnaise, Parsley, Ciabatta"], price: ["289"] },
                    // { name: ["Hovězí tatarák", "Beef Tartare"], subtitle: ["dijonská majonéza, hrubozrnná hořčice, ciabatta", "Dijon Mayonnaise, Wholegrain Mustard, Ciabatta"], price: ["319"] },
                    // { name: ["Burrata Caprese", "Bruschetta"], subtitle: ["rajčata, bazalkové pesto, bruschetta", "onion ricotta, dried tomatoes, Parma ham, basil"], price: ["219"] },
                    {
                        name: ["Krevety", "Shrimps"],
                        subtitle: [
                            "česnek, máslo, chilli, víno, bruschetta",
                            "Garlic, Butter, Chilli, Wine, Bruschetta",
                        ],
                        price: ["349"],
                    },

                    {
                        name: [
                            "Selekce sýrů a uzenin, focaccia ",
                            "Cheese and Charcuterie Selection, Focaccia",
                        ],
                        subtitle: [
                            "parmská šunka, mortadella, grana padano, feta, sušená rajčata, olivy, focaccia",
                            "Parma Ham, Mortadella, Grana Padano, Feta, Sun-dried Tomatoes, Olives, Focaccia",
                        ],
                        price: ["299"],
                    },
                ],
            },
            {
                name: ["Polévky", "Soups"],
                level: 1,
                items: [
                    // { name: ["Minestrone", "Minestrone"], subtitle: ["bazalkové pesto", "basil pesto"], price: ["99"] },
                    {
                        name: ["Kuřecí vývar", "Chicken Broth"],
                        subtitle: [
                            "maso, celestýnské nudle, mrkev, pažitka",
                            "meat, celestine noodles, carrot, chives",
                        ],
                        price: ["99"],
                    },
                    {
                        name: ["Rajčatový krém", "Tomato cream"],
                        subtitle: ["Grana Padano", "Grana Padano"],
                        price: ["109"],
                    },
                ],
            },
            {
                name: ["Pasta a risotto", "Pasta & risotto"],
                level: 1,
                items: [
                    {
                        name: [
                            "Aglio olio e peperoncino / rump steak",
                            "Aglio Olio e peperoncino / rump steak",
                        ],
                        price: ["199/319"],
                    },

                    // { name: ["Bolognese", "Bolognese"], subtitle: ["hovězí krk, drcená rajčata, grana padano", "Beef neck, Crushed Tomatoes, Grana Padano"], price: ["299"] },
                    {
                        name: ["Di Maiale", "Di Maiale"],
                        subtitle: [
                            "vepřová panenka, grana padano, smetana, červená cibule, pažitka",
                            "Pork Tenderloin, Grana Padano, Cream, Red Onion, Chives",
                        ],
                        price: ["249"],
                    },
                    {
                        name: [
                            "Al Pesto Genovese burrata / kuřecí maso",
                            "Al Pesto Genovese burrata / chicken",
                        ],
                        subtitle: [
                            "bazalka, mandle, česnek, grana padano",
                            "Basil, Almonds, Garlic, Grana Padano",
                        ],
                        price: ["289/299"],
                    },
                    {
                        name: ["Alla Carbonara ", "Alla Carbonara "],
                        subtitle: [
                            "pancetta, žloutky, grana padano, pepř",
                            "Pancetta, Egg Yolks, Grana Padano, Pepper",
                        ],
                        price: ["279"],
                    },
                    {
                        name: ["Gamberetti", "Gamberetti"],
                        subtitle: [
                            "krevety, máslo, grana padano, česnek, víno, pepř",
                            "Shrimps, Butter, Grana Padano, Garlic, Wine, Pepper",
                        ],
                        price: ["359"],
                    },
                    // { name: ["Ravioli ricotta e spinaci", "Ravioli ricotta e spinaci"], subtitle: ["máslová omáčka, šalvěj, grana padano", "Butter Sauce, Sage, Grana Padano"], price: ["289"] },
                    {
                        name: ["Risotto limone", "Risotto limone"],
                        subtitle: [
                            "kuřecí maso, grana padano, citron, bazalka",
                            "Chicken, Grana Padano, Lemon, Basil",
                        ],
                        price: ["269"],
                    },

                    {
                        name: [
                            "Risotto s pecorinem, pepřem a pancettou",
                            "Risotto with Pecorino, Pepper, and Pancetta",
                        ],
                        subtitle: [
                            "Pecorino Romano, pepř, pancetta",
                            "Pecorino Romano, Pepper, Pancetta",
                        ],
                        price: ["269"],
                    },
                ],
            },
            // {
            //     name: ["Risotta", "Risottos"],
            //     level: 1,
            //     items: [
            //         { name: ["Risotto ai funghi porcini", "Risotto ai Funghi Porcini"], subtitle: ["máslo, grana padano, hřib hnědý", "Butter, Grana Padano, Porcini Mushrooms"], price: ["299"] },
            //         { name: ["Risotto parmigiano", "Risotto Parmigiano"], subtitle: ["hovězí líčka, gremolata", "beef cheeks, gremolata"], price: ["449"] },
            //     ]
            // },
            {
                name: ["Ryby", "Fish"],
                level: 1,
                items: [
                    // { name: ["Filet z pražmy královské", "King Bream Fillet"], subtitle: ["koprový jogurt, chorizo, baby brambory, šalotka", "Dill Yogurt, Chorizo, Baby Potatoes, Shallots"], price: ["419"] },
                    // { name: ["Ryba dne", "Fish of the Day"], subtitle: ["grilovaná zelenina, holadská omáčka", "Grilled Vegetables, Hollandaise Sauce"], price: ["499"] },
                    {
                        name: ["Mořský vlk", "Sea Bass"],
                        subtitle: ["omáčka beurre blanc", "beurre blanc sauce"],
                        price: ["299"],
                    },
                ],
            },

            {
                name: ["Maso", "Meat"],
                level: 1,
                items: [
                    {
                        name: [
                            "Farmářské kuřecí prso, slaninovo-hořčičná omáčka",
                            "Farmers’ Chicken Breast",
                        ],
                        price: ["219"],
                    },
                    {
                        name: [
                            "Vepřová panenka na rozmarýnu sous vide",
                            "Pork Tenderloin sous vide",
                        ],
                        price: ["229"],
                    },
                    { name: ["Rump steak ", "Rump steak "], price: ["359"] },
                    {
                        name: ["Burger s hovězím masem", "Beef Burger"],
                        subtitle: [
                            "cheddar, slanina, cibulová marmeláda, salát, chipotle majonéza, batátové / bramborové hranolky",
                            "Cheddar, Bacon, Onion Marmalade, Lettuce, Chipotle Mayo, Sweet Potato / French Fries",
                        ],
                        price: ["429"],
                    },

                    // { name: ["Marinovaná vepřová krkovice barbecue sous-vide", "Marinated Pork Neck barbecue sous-vide"], price: ["199"] },
                    // { name: ["Hovězí svíčková", "Beef Tenderloin"], price: ["599"] },
                    // { name: ["Burger s kozím sýrem", "Goat Cheese Burger"], subtitle: ["majonéza se sušenými rajčaty, karamelizovaná cibule, rukola, batátové/bramborové hranolky", "Sun-dried Tomato Mayo, Caramelized Onion, Arugula, Sweet Potato / French Fries"], price: ["349"] },
                ],
            },
            // {
            //     name: ["Každý pátek a sobotu:", "Every Friday and Saturday:"],
            //     level: 2,
            //     items: [
            //         { name: ["New One burger", "New One Burger"], subtitle: ["hovězí mletý krk, cheddar, rajče, cibulová marmeláda, chipotle, uzená majonéza, bramborové hranolky", "Ground Beef, Cheddar, Tomato, Onion Marmalade, Chipotle, Smoked Mayonnaise, French Fries"], price: ["419"] },
            //     ]
            // },
            {
                name: ["Přílohy", "Side Dishes"],
                level: 1,
                items: [
                    {
                        name: ["Bramborová kaše", "Mashed potatoes"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Grilovaná zelenina", "Grilled vegetables"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    // { name: ["Grilovaná cuketa", "Grilled zucchini"], subtitle: ["se slunečnicovými semínky", "with sunflower seeds"], price: ["89"] },
                    {
                        name: ["Míchaný listový salát", "Mixed salad"],
                        subtitle: [
                            "mrkev, cherry rajčata, balsamico dressing",
                            "carrot, cherry tomatoes, balsamic dressing",
                        ],
                        price: ["89"],
                    },

                    {
                        name: [
                            "Grenaille s rozmarýnem",
                            "Grenaille Potatoes with Rosemary",
                        ],
                        price: ["99"],
                    },

                    // { name: ["Toskánské brambory", "Tuscan potatoes"], subtitle: ["pancetta, česnek, rozmarýn", "pancetta, garlic, rosemary"], price: ["99"] },
                    {
                        name: ["Bramborové hranolky", "French Fries"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: ["Batátové hranolky", "Sweet Potato fries"],
                        subtitle: [""],
                        price: ["99"],
                    },

                    {
                        name: ["Focaccia", "Focaccia"],
                        subtitle: [""],
                        price: ["59"],
                    },
                ],
            },

            {
                name: ["Omáčky", "Sauces"],
                level: 1,
                items: [
                    {
                        name: ["Dijonská majonéza", "Dijon Mayonnaise"],
                        subtitle: [""],
                        price: ["59"],
                    },
                    {
                        name: ["Pepřová", "Pepper sauce"],
                        subtitle: [""],
                        price: ["89"],
                    },

                    // { name: ["Masová z pancetty", "Meat Sauce with Pancetta"], subtitle: [""], price: ["89"] },
                    // { name: ["Beurre blanc (máslo, víno)", "Beurre Blanc (Butter, Wine)"], subtitle: [""], price: ["89"] },
                    {
                        name: ["Parmazánová", "Parmesan sauce"],
                        subtitle: [""],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Saláty", "Salads"],
                level: 1,
                items: [
                    {
                        name: ["Caesar salát", "Caesar Salad"],
                        subtitle: [
                            "kuřecí maso, pancetta, krutony, grana padano",
                            "chicken, pancetta, croutons, Grana Padano",
                        ],
                        price: ["329"],
                    },
                    {
                        name: ["Salát s kozím sýrem", "Salad with goat cheese"],
                        subtitle: [
                            "nakládaný fenykl, pomeranč, mandle v medu, balsamico dresink",
                            "Pickled fennel, Orange, Honey Almonds, Balsamic Dressing",
                        ],
                        price: ["339"],
                    },

                    {
                        name: [
                            "Salát s hovězím rump steakem",
                            "Rump Steak Salad",
                        ],
                        subtitle: [
                            "cherry rajčata, parmazánový chips, dresink z hrubozrnné hořčice",
                            "Cherry tomatoes, Parmesan Chip, Wholegrain Mustard Dressing",
                        ],
                        price: ["349"],
                    },
                    // { name: ["Salát s hovězí svíčkovou", "Salad with Beef Tenderloin"], subtitle: ["míchaný salát, olivy taggiasche, cherry rajčata, smažená cizrna, sezam", "mixed salad, Taggiasca olives, cherry tomatoes, fried chickpeas, sesame"], price: ["389"] },
                ],
            },
            {
                name: ["Pochutiny", "Snacks"],
                level: 1,
                items: [
                    {
                        name: ["Pražené mandle", "Roasted Almonds"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Grissini", "Grissini"],
                        subtitle: [""],
                        price: ["59"],
                    },
                    {
                        name: ["Marinované olivy", "Marinated Olives"],
                        subtitle: [""],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Dezerty", "Desserts"],
                level: 1,
                items: [
                    {
                        name: ["Tiramisu", "Tiramisu"],
                        subtitle: [""],
                        price: ["129"],
                    },
                ],
            },
        ],
    }, */

    {
        category: ["Snídaně à la carte", "à la carte breakfast"],
        time: [
            "Snídaně podáváme ve dnech pondělí až pátek do 11:00 hod., o víkendech a svátcích do 11:30 hod.",
            "Breakfast is served Monday–Friday until 11:00, weekends and holidays until 11:30.",
        ],
        footer: [
            "V rušnějších chvílích Vám děkujeme za trpělivost, odměnou vám bude snídaně připravená s láskou.",
            "At busier times, we thank you for your patience—your reward will be a breakfast prepared with love.",
        ],
        groups: [
            {
                name: [""],
                level: 1,
                items: [
                    {
                        name: ["Káva a croissant", "Coffee and croissant"],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["109"],
                    },
                    {
                        name: [
                            "Káva a croissant a pomerančový džus",
                            "Coffee, croissant and orange juice",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["149"],
                    },
                    {
                        name: [
                            "Vejce míchaná 3 ks s pažitkou, máslo a pečivo",
                            "Scrambled eggs (3) with chives, butter and bread",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "6", "7", "11"],
                        price: ["139"],
                    },
                    {
                        name: [
                            "Vejce míchaná 3 ks s cibulkou a pažitkou, máslo a pečivo",
                            "Scrambled eggs (3) with onion and chives, butter and bread",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "6", "7", "11"],
                        price: ["149"],
                    },
                    {
                        name: ["3 vejce do skla", "3 eggs in a glass"],
                        subtitle: [
                            "grana padano, pažitka, toast, máslo",
                            "Grana Padano, chives, toast, butter",
                        ],
                        allergens: ["1a", "3", "7", "12"],
                        price: ["169"],
                    },
                    {
                        name: ["Palačinka", "Pancake"],
                        subtitle: [
                            "marmeláda z lesního ovoce, šlehaný tvaroh",
                            "wild berry jam, whipped curd cheese",
                        ],
                        allergens: ["1a", "3", "7"],
                        price: ["199"],
                    },
                    {
                        name: [
                            "Buchtičky s vanilkovým krémem",
                            "Sweet buns with vanilla cream",
                        ],
                        subtitle: ["", ""],
                        allergens: ["1a", "3", "7"],
                        price: ["199"],
                    },
                    {
                        name: ["Ovesná kaše", "Oatmeal"],
                        subtitle: [
                            "pečené meruňky, lískoořechové máslo",
                            "baked apricots, hazelnut butter",
                        ],
                        allergens: ["1d", "3", "8b"],
                        price: ["219"],
                    },
                    {
                        name: ["Ovesná protein kaše", "Protein oatmeal"],
                        subtitle: [
                            "pečené meruňky, lískoořechové máslo",
                            "baked apricots, hazelnut butter",
                        ],
                        allergens: ["1d", "3", "8b"],
                        price: ["269"],
                    },
                    {
                        name: ["Francouzská brioška", "French brioche"],
                        subtitle: [
                            "meruňky, šlehaný tvaroh",
                            "apricots, whipped curd cheese",
                        ],
                        allergens: ["1a", "3", "5", "7", "8a", "8b", "8c", "8d"],
                        price: ["219"],
                    },
                    {
                        name: ["New One granola", "New One granola"],
                        subtitle: [
                            "řecký jogurt, med, ovoce",
                            "Greek yogurt, honey, fruit",
                        ],
                        allergens: ["1a", "5", "7", "8a", "8b", "8c", "8d"],
                        price: ["219"],
                    },
                    {
                        name: [
                            "Vaječná omeleta ze 3 vajec",
                            "Three-egg omelette",
                        ],
                        subtitle: [
                            "pražská šunka, baby špenát, brie, pečivo",
                            "Prague ham, baby spinach, Brie, bread",
                        ],
                        allergens: ["1a", "3", "6", "7", "10", "12"],
                        price: ["219"],
                    },
                    {
                        name: ["New One bagel", "New One bagel"],
                        subtitle: [
                            "volská oka 2 ks, slanina, cheddar",
                            "two fried eggs, bacon, cheddar",
                        ],
                        allergens: ["1a", "3", "7", "10", "11", "12"],
                        price: ["219"],
                    },
                    {
                        name: ["Vejce do misky", "Eggs in a bowl"],
                        subtitle: [
                            "holandská omáčka, pancetta, pažitka, pečivo",
                            "hollandaise sauce, pancetta, chives, bread",
                        ],
                        allergens: ["1a", "3", "7", "12"],
                        price: ["219"],
                    },
                    {
                        name: ["Vejce Benedikt", "Eggs Benedict"],
                        subtitle: [
                            "holandská omáčka, zastřené vejce, pečená šunka od kosti",
                            "hollandaise sauce, poached egg, baked ham off the bone",
                        ],
                        allergens: ["1a", "3", "7", "12"],
                        price: ["249"],
                    },
                    {
                        name: ["Vejce Florentine", "Eggs Florentine"],
                        subtitle: [
                            "holandská omáčka, zastřené vejce, baby špenát",
                            "hollandaise sauce, poached egg, baby spinach",
                        ],
                        allergens: ["1a", "3", "7", "12"],
                        price: ["249"],
                    },
                    {
                        name: ["Anglická snídaně", "English breakfast"],
                        subtitle: [
                            "volská oka 2 ks, bavorské klobásky, fazole v tomatě, slanina, žampiony, rajče, máslo, pečivo",
                            "two fried eggs, Bavarian sausages, beans in tomato, bacon, mushrooms, tomato, butter, bread",
                        ],
                        allergens: ["1a", "3", "6", "7", "11"],
                        price: ["339"],
                    },
                ],
            },
            {
                name: ["Nápoje", "Drinks"],
                level: 1,
                items: [
                    {
                        name: ["Pomerančový fresh juice", "Orange fresh juice"],
                        subtitle: ["0,2l", "0,2l"],
                        price: ["99"],
                    },
                    {
                        name: ["Jablečný fresh juice", "Apple fresh juice"],
                        subtitle: ["0,2l", "0,2l"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grapefruitový fresh juice",
                            "Grapefruit fresh juice",
                        ],
                        subtitle: ["0,2l", "0,2l"],
                        price: ["99"],
                    },
                    {
                        name: ["Jahodové smoothie", "Strawberry smoothie"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Banánové smoothie s pomerančem",
                            "Banana smoothie with orange",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Smoothie z lesního ovoce",
                            "Forest fruit smoothie",
                        ],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Káva", "Coffee"],
                level: 1,
                items: [
                    {
                        name: ["Espresso", "Espresso"],
                        subtitle: ["", ""],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Espresso speciál (výběrová 100% Arabica)",
                            "Espresso special (selected 100% Arabica)",
                        ],
                        subtitle: ["", ""],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso ristretto", "Espresso ristretto"],
                        subtitle: ["", ""],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso lungo", "Espresso lungo"],
                        subtitle: ["", ""],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso doppio", "Espresso doppio"],
                        subtitle: ["", ""],
                        price: ["89"],
                    },
                    {
                        name: ["Espresso tonic", "Espresso tonic"],
                        subtitle: ["", ""],
                        price: ["99"],
                    },
                    {
                        name: ["Espresso macchiato", "Espresso macchiato"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["69"],
                    },
                    {
                        name: ["Cappuccino", "Cappuccino"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["79"],
                    },
                    {
                        name: ["Cappuccino doppio", "Cappuccino doppio"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: ["Flat white", "Flat white"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Caffè latte macchiato",
                            "Caffè latte macchiato",
                        ],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè latte", "Caffè latte"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè latte jumbo", "Caffè latte jumbo"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: ["Frappuccino", "Frappuccino"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: ["Caffè gelato", "Caffè gelato"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: ["Caffè bombardino", "Caffè bombardino"],
                        subtitle: ["", ""],
                        allergens: ["3", "7"],
                        price: ["109"],
                    },
                    {
                        name: ["Irish Coffee", "Irish Coffee"],
                        subtitle: ["", ""],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: [
                            "Příchuť kávy dle nabídky",
                            "Coffee flavour of your choice",
                        ],
                        subtitle: ["", ""],
                        price: ["10"],
                    },
                    {
                        name: [
                            "Všechny kávy mohou být připraveny bezkofeinové a za příplatek 20,-Kč s bezlaktózovým mlékem",
                            "All coffees can be prepared decaffeinated and with lactose-free milk for an extra 20 CZK",
                        ],
                    },
                ],
            },
            {
                name: ["Čaje", "Tea"],
                level: 1,
                items: [
                    {
                        name: [
                            "Z čerstvé máty s medem",
                            "Fresh mint with honey",
                        ],
                        subtitle: ["", ""],
                        price: ["79"],
                    },
                    {
                        name: [
                            "Z čerstvého zázvoru s medem",
                            "Fresh ginger with honey",
                        ],
                        subtitle: ["", ""],
                        price: ["79"],
                    },
                    {
                        name: ["Sypaný čaj Althaus", "Loose-leaf tea Althaus"],
                        subtitle: ["", ""],
                        price: ["79"],
                    },
                ],
            },
            {
                name: ["Skupiny alergenů:", "Allergen groups:"],
                level: 1,
                items: [
                    {
                        name: [
                            "1a) pšenice, 1b) žito, 1c) ječmen, 1d) oves, 2) korýši a výrobky z nich, 3) vejce a výrobky z nich, 4) ryby a výrobky z nich, 5) arašídy a výrobky z nich, 6) sojové boby a výrobky z nich, 7) mléko a výrobky z něj, 8a) mandle, 8b) lískové ořechy, 8c) vlašské ořechy, 8d) kešu ořechy, 8e) pekanové ořechy, 8f) para ořechy, 8g) pistácie, 8h) makadamie, 9) celer a výrobky z něj, 10) hořčice a výrobky z ní, 11) sezamová semena, 12) oxid siřičitý a siřičitany, 13) vlčí bob a výrobky z něj, 14) měkkýši a výrobky z nich",
                            "1a) wheat, 1b) rye, 1c) barley, 1d) oats, 2) crustaceans and products thereof, 3) eggs and products thereof, 4) fish and products thereof, 5) peanuts and products thereof, 6) soybeans and products thereof, 7) milk and products thereof, 8a) almonds, 8b) hazelnuts, 8c) walnuts, 8d) cashews, 8e) pecans, 8f) brazil nuts, 8g) pistachios, 8h) macadamia nuts, 9) celery and products thereof, 10) mustard and products thereof, 11) sesame seeds, 12) sulphur dioxide and sulphites, 13) lupin and products thereof, 14) molluscs and products thereof",
                        ],
                    },
                ],
            },
        ],
    },
    /* {
        category: ["Snídaně à la carte", "à la carte breakfast"],
        groups: [
            {
                name: [""],
                level: 1,
                items: [
                    {
                        name: ["Káva a croissant", "Coffee and Croissant"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Káva, croissant a pomerančový džus",
                            "Coffee, Croissant & Orange Juice ",
                        ],
                        subtitle: [""],
                        price: ["139"],
                    },
                    // { name: ["New One granola", "New One Granola"], subtitle: ["řecký jogurt, arašídové máslo, ovoce", "Greek yoghurt, peanut butter, fruit"], price: ["179"] },
                    {
                        name: [
                            "Vejce míchaná 3 ks s pažitkou / s cibulkou a pažitkou",
                            "Scrambled Eggs (3 Eggs) with Chives / with Onions and Chives",
                        ],
                        subtitle: ["máslo, pečivo", "Butter, Bread"],
                        price: ["119/129"],
                    },
                    {
                        name: ["3 vejce do skla", "3 Eggs in a Glass"],
                        subtitle: [
                            "grana padano, pažitka, toast, máslo",
                            "Grana Padano, Chives, Toast, Butter",
                        ],
                        price: ["149"],
                    },
                    {
                        name: [
                            "Buchtičky s vanilkovým krémem",
                            "Mini Buns with Vanilla Custard",
                        ],
                        price: ["189"],
                    },
                    {
                        name: ["Ovesná kaše", "Oatmeal"],
                        subtitle: [
                            "pečené meruňky, lískoořechové máslo s čokoládou ",
                            "Roasted Apricots, Chocolate Hazelnut Butter",
                        ],
                        price: ["189"],
                    },
                    {
                        name: ["New One granola", "Pancake with nutella"],
                        subtitle: [
                            " řecký jogurt, lískoořechové máslo s čokoládou, ovoce",
                            "Greek Yogurt, Chocolate Hazelnut Butter, Fruit",
                        ],
                        price: ["199"],
                    },
                    {
                        name: ["Palačinka s povidly,", "Crepe with Plum Jam"],
                        subtitle: [
                            " pečené švestky, šlehaný tvaroh",
                            "Roasted Plums, Whipped Quark",
                        ],
                        price: ["199"],
                    },
                    {
                        name: [
                            "Vaječná omeleta ze 3 vajec",
                            "Egg Omelette with 3 Eggs",
                        ],
                        subtitle: [
                            "pražská šunka, baby špenát, uzená scamorza, pečivo",
                            "Prague Ham, Baby Spinach, Smoked Scamorza Cheese, Bread",
                        ],
                        price: ["199"],
                    },
                    {
                        name: ["New One bagel", "New One Bagel"],
                        subtitle: [
                            "(volská oka 2 ks, slanina, cheddar) ",
                            " 2 Fried Eggs, Bacon, Cheddar",
                        ],
                        price: ["199"],
                    },
                    {
                        name: ["Vejce Florentine", "Eggs Florentine"],
                        subtitle: [
                            "zastřené vejce, holandská omáčka, baby špenát, pečivo",
                            "poached egg, Hollandaise sauce, baby spinach, bread",
                        ],
                        price: ["239"],
                    },
                    {
                        name: ["Vejce Benedikt", "Eggs Benedict"],
                        subtitle: [
                            "zastřené vejce, holandská omáčka, pečená šunka od kosti, pečivo",
                            "poached egg, Hollandaise sauce, baked ham off the bone, bread",
                        ],
                        price: ["239"],
                    },
                    {
                        name: ["Anglická snídaně", "English Breakfast"],
                        subtitle: [
                            "vejce, bavorská klobása, fazole, slanina, žampiony, rajče, máslo, pečivo",
                            "eggs, Bavarian sausage, beans, bacon, mushrooms, tomato, butter, bread",
                        ],
                        price: ["319"],
                    },
                ],
            },
            {
                name: ["Nápoje", "Drinks"],
                level: 1,
                items: [
                    {
                        name: ["Pomerančový fresh juice", "Fresh Orange Juice"],
                        subtitle: ["0,2l"],
                        price: ["99"],
                    },
                    {
                        name: ["Jablečný fresh juice", "Fresh Apple Juice"],
                        subtitle: ["0,2l"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grapefruitový fresh juice",
                            "Fresh Grapefruit Juice",
                        ],
                        subtitle: ["0,2l"],
                        price: ["99"],
                    },
                    {
                        name: ["Jahodové smoothie", "Strawberry Smoothie"],
                        subtitle: ["0,4l"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Banánové smoothie s pomerančem",
                            "Banana Smoothie with Orange",
                        ],
                        subtitle: ["0,4l"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Smoothie z lesního ovoce",
                            "Forest Fruits Smoothie",
                        ],
                        subtitle: ["0,4l"],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Káva", "Coffee"],
                level: 1,
                items: [
                    {
                        name: ["Espresso", "Espresso"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso speciál", "Espresso of the Day"],
                        subtitle: ["(dle denní nabídky)", null],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso ristretto", "Espresso Ristretto"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso lungo", "Espresso Lungo"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso doppio", "Espresso Doppio"],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Espresso tonic", "Espresso Tonic"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Espresso macchiato", "Espresso Macchiato"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Cappuccino", "Cappuccino"],
                        subtitle: [""],
                        price: ["79"],
                    },
                    {
                        name: ["Cappuccino doppio", "Cappuccino Doppio"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: ["Flat white", "Flat White"],
                        subtitle: [""],
                        price: ["95"],
                    },
                    {
                        name: [
                            "Caffè latte macchiato",
                            "Caffè Latte Macchiato",
                        ],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Caffè latte", "Caffè Latte"],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Caffè latte jumbo", "Caffè Latte Jumbo"],
                        subtitle: [""],
                        price: ["109"],
                    },
                    {
                        name: ["Frappuccino", "Frappuccino"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè gelato", "Caffè Gelato"],
                        subtitle: [
                            "(se zmrzlinou a šlehačkou)",
                            "(with Ice Cream and Whipped Cream)",
                        ],
                        price: ["109"],
                    },
                    {
                        name: ["Caffè bombardino", "Caffè Bombardino"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: ["Irish Coffee", "Caffè Irlandese"],
                        subtitle: [
                            "(s whiskey a šlehačkou)",
                            "(with Whiskey and Cream)",
                        ],
                        price: ["109"],
                    },
                    {
                        name: [
                            "Příchuť do kávy dle nabídky",
                            "Coffee Flavour of the Day",
                        ],
                        price: ["10"],
                    },
                    {
                        name: [
                            "Všechny kávy mohou být připraveny bezkofeinové a za příplatek 20,- Kč s bezlaktózovým mlékem.",
                            "All coffees can be prepared decaffeinated for an additional fee of 20 CZK with lactose-free milk.",
                        ],
                    },
                ],
            },
            {
                name: ["Čaje", "Tea"],
                level: 1,
                items: [
                    {
                        name: [
                            "Z čerstvé máty s medem",
                            "Fresh Mint Tea with Honey",
                        ],
                        subtitle: [""],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Z čerstvého zázvoru s medem",
                            "Fresh Ginger Tea with Honey",
                        ],
                        subtitle: [""],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Sypaný čaj Tea Forte",
                            "Tea Forte Loose Leaf Tea",
                        ],
                        subtitle: [""],
                        price: ["79"],
                    },
                ],
            },
        ],
    }, */

    {
        category: ["Nápojový list", "Drink menu"],
        groups: [
            {
                name: ["Nápoje", "Drinks"],
                items: [
                    {
                        name: ["Limonáda", "Lemonade"],
                        subtitle: [
                            "bezinková, citronová, zázvorová, angreštová, americká, rakytníková, mangová, okurková",
                            "elderflower, lemon, ginger, gooseberry, American, sea buckthorn, mango, cucumber",
                        ],
                        price: ["89"],
                    },
                    {
                        name: [
                            "Pomerančový fresh juice 0,2l",
                            "Orange fresh juice 0,2l",
                        ],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Jablečný fresh juice 0,2l",
                            "Apple fresh juice 0,2l",
                        ],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grapefruitový fresh juice 0,2l",
                            "Grapefruit fresh juice 0,2l",
                        ],
                        price: ["99"],
                    },
                    {
                        name: ["Jahodové smoothie", "Strawberry smoothie"],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Banánové smoothie s pomerančem",
                            "Banana smoothie with orange",
                        ],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Smoothie z lesního ovoce",
                            "Forest fruit smoothie",
                        ],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Vody", "Water"],
                items: [
                    {
                        name: [
                            "Mattoni perlivá / jemně perlivá / neperlivá 0,33l",
                            "Mattoni sparkling / lightly sparkling / still 0,33l",
                        ],
                        price: ["49"],
                    },
                    {
                        name: [
                            "Römerquelle perlivá / neperlivá 0,33l / 0,75l",
                            "Römerquelle sparkling / still 0,33l / 0,75l",
                        ],
                        price: ["69 / 119"],
                    },
                    {
                        name: [
                            "Römerquelle lemongrass 0,33l",
                            "Römerquelle lemongrass 0,33l",
                        ],
                        price: ["79"],
                    },
                    {
                        name: [
                            "Karafa filtrované vody perlivá / neperlivá 0,5l/1l",
                            "Carafe of filtered water sparkling / still 0,5l/1l",
                        ],
                        price: ["39 / 59"],
                    },
                    {
                        name: ["San Pellegrino 0,25l", "San Pellegrino 0,25l"],
                        price: ["79"],
                    },
                    {
                        name: ["Acqua Panna 0,25l", "Acqua Panna 0,25l"],
                        price: ["79"],
                    },
                ],
            },
            {
                name: ["Džusy", "Juices"],
                items: [
                    {
                        name: ["Cappy"],
                        subtitle: [
                            "pomeranč, jablko, multivitamin, ananas, jahoda, černý rybíz, broskev, hruška, grapefruit 0,2l",
                            "orange, apple, multivitamin, pineapple, strawberry, black currant, peach, pear, grapefruit 0,2l",
                        ],
                        price: ["69"],
                    },
                ],
            },
            {
                name: ["Nealkoholické nápoje", "Non-alcoholic beverages"],
                items: [
                    {
                        name: [
                            "Coca-Cola / Coca-Cola Zero 0,33l",
                            "Coca-Cola / Coca-Cola Zero 0,33l",
                        ],
                        price: ["69"],
                    },
                    {
                        name: ["Coca-Cola ochucená", "Flavoured Coca-Cola"],
                        subtitle: [
                            "vanilla, cherry, passion fruit",
                            "vanilla, cherry, passion fruit",
                        ],
                        price: ["69"],
                    },
                    {
                        name: ["Sprite, Fanta 0,33l", "Sprite, Fanta 0,33l"],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Kinley Tonic Water, Kinley Ginger Ale, Kinley Bitter Rose 0,25l",
                            "Kinley Tonic Water, Kinley Ginger Ale, Kinley Bitter Rose 0,25l",
                        ],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Ledový čaj broskev / citron",
                            "Iced tea peach / lemon",
                        ],
                        price: ["79"],
                    },
                    {
                        name: ["Red Bull 0,25l", "Red Bull 0,25l"],
                        price: ["89"],
                    },
                    {
                        name: ["Fever-Tree Premium Indian Tonic Water"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Crodino Biondo / Crodino Rosso 0,175l",
                            "Crodino Biondo / Crodino Rosso 0,175l",
                        ],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Pivo", "Beer"],
                items: [
                    {
                        name: [
                            "Pilsner Urquell čepovaný 0,4l",
                            "Pilsner Urquell draft 0,4l",
                        ],
                        allergens: ["1", "12"],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Elektrárna speciál čepovaný 0,4l",
                            "Elektrárna speciál draft 0,4l",
                        ],
                        allergens: ["1", "12"],
                        price: ["89"],
                    },
                    {
                        name: [
                            "Radegast Birell bottle 0,33l",
                            "Radegast Birell bottle 0,33l",
                        ],
                        allergens: ["1", "12"],
                        price: ["49"],
                    },
                    {
                        name: [
                            "Stella Artois ležák / nealko 0,33l",
                            "Stella Artois lager / non-alco 0,33l",
                        ],
                        allergens: ["1", "12"],
                        price: ["59"],
                    },
                    {
                        name: [
                            "Apple Cider lahvový 0,4l",
                            "Apple Cider bottle 0,4l",
                        ],
                        allergens: ["1", "12"],
                        price: ["69"],
                    },
                    {
                        name: ["Corona lahvová 0,33l", "Corona bottle 0,33l"],
                        allergens: ["1", "12"],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Káva", "Coffee"],
                items: [
                    {
                        name: ["Espresso", "Espresso"],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Espresso speciál (výběrová 100% Arabica)",
                            "Espresso special (selected 100% Arabica)",
                        ],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso ristretto", "Espresso ristretto"],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso lungo", "Espresso lungo"],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso doppio", "Espresso doppio"],
                        price: ["89"],
                    },
                    {
                        name: ["Espresso tonic", "Espresso tonic"],
                        price: ["99"],
                    },
                    {
                        name: ["Espresso macchiato", "Espresso macchiato"],
                        allergens: ["7"],
                        price: ["69"],
                    },
                    {
                        name: ["Cappuccino", "Cappuccino"],
                        allergens: ["7"],
                        price: ["79"],
                    },
                    {
                        name: ["Cappuccino doppio", "Cappuccino doppio"],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: ["Flat white", "Flat white"],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: ["Frappuccino", "Frappuccino"],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Caffè latte macchiato",
                            "Caffè latte macchiato",
                        ],
                        allergens: ["7"],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè latte", "Caffè latte"],
                        allergens: ["7"],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè latte jumbo", "Caffè latte jumbo"],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: ["Caffè bombardino", "Caffè bombardino"],
                        allergens: ["3", "7"],
                        price: ["109"],
                    },
                    {
                        name: ["Caffè gelato", "Caffè gelato"],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: ["Irish Coffee", "Irish Coffee"],
                        allergens: ["7"],
                        price: ["109"],
                    },
                    {
                        name: [
                            "Příchuť do kávy dle nabídky",
                            "Coffee flavour of your choice",
                        ],
                        price: ["10"],
                    },
                    {
                        name: [
                            "Všechny kávy mohou být připraveny bezkofeinové a za příplatek 20 Kč s bezlaktózovým mlékem.",
                            "All coffees can be prepared decaffeinated and with lactose-free milk for an extra 20 CZK.",
                        ],
                    },
                ],
            },
            {
                name: ["Čaje", "Tea"],
                items: [
                    {
                        name: [
                            "Z čerstvé máty s medem",
                            "Fresh mint with honey",
                        ],
                        price: ["79"],
                    },
                    {
                        name: [
                            "Z čerstvého zázvoru s medem",
                            "Fresh ginger with honey",
                        ],
                        price: ["79"],
                    },
                    {
                        name: ["Sypaný čaj Althaus", "Loose-leaf tea Althaus"],
                        price: ["79"],
                    },
                ],
            },
            {
                name: ["Teplé nápoje", "Hot drinks"],
                items: [
                    {
                        name: ["Horká čokoláda", "Hot chocolate"],
                        allergens: ["7"],
                        price: ["99"],
                    },
                    {
                        name: ["Svařené víno", "Mulled wine"],
                        allergens: ["12"],
                        price: ["89"],
                    },
                    {
                        name: [
                            "Bombardino se šlehačkou",
                            "Bombardino with whipped cream",
                        ],
                        allergens: ["3", "7"],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Italské spirity", "Italian spirits"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Aperol Aperitivo"],
                        price: ["69"],
                    },
                    {
                        name: ["Amaretto Disaronno Originale"],
                        price: ["79"],
                    },
                    {
                        name: ["Amaro Averna"],
                        price: ["79"],
                    },
                    {
                        name: ["Amaro Ramazzotti"],
                        price: ["79"],
                    },
                    {
                        name: ["Campari Bitter"],
                        price: ["79"],
                    },
                    {
                        name: ["Frangelico Liqueur"],
                        price: ["79"],
                    },
                    {
                        name: ["Grappa Fior di Vite"],
                        price: ["89"],
                    },
                    {
                        name: ["Galliano"],
                        price: ["89"],
                    },
                    {
                        name: ["Italicus Rosolio di Bergamotto"],
                        price: ["129"],
                    },
                    {
                        name: ["Limoncello Walcher"],
                        price: ["79"],
                    },
                    {
                        name: ["Luxardo Maraschino Originale"],
                        price: ["79"],
                    },
                ],
            },
            {
                name: ["Vermuty", "Vermouth"],
                level: 1,
                volume: "10 cl",
                items: [
                    {
                        name: ["Martini Extra Dry"],
                        price: ["89"],
                    },
                    {
                        name: ["Martini Bianco"],
                        price: ["89"],
                    },
                    {
                        name: ["Martini Rosato"],
                        price: ["89"],
                    },
                    {
                        name: ["Martini Rosso"],
                        price: ["89"],
                    },
                    {
                        name: ["Martini Fiero"],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Giny", "Gin"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Beefeater London Dry Gin"],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Beefeater Pink Strawberry / Peach & Raspberry / Blood Orange",
                        ],
                        price: ["69"],
                    },
                    {
                        name: ["Bombay Sapphire Dry Gin"],
                        price: ["89"],
                    },
                    {
                        name: [
                            "Citadelle Original / Rouge / Jardin d'Été / Vive Le Cornichon",
                        ],
                        price: ["99"],
                    },
                    {
                        name: ["Gin Sul"],
                        price: ["199"],
                    },
                    {
                        name: ["Hendrick's Gin"],
                        price: ["119"],
                    },
                    {
                        name: ["Malfy Gin Originale"],
                        price: ["119"],
                    },
                    {
                        name: ["Malfy Gin Rosa"],
                        price: ["119"],
                    },
                    {
                        name: ["Monkey 47"],
                        price: ["199"],
                    },
                    {
                        name: ["Plymouth Gin"],
                        price: ["99"],
                    },
                    {
                        name: ["Tanqueray London Dry Gin"],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Whisk(e)y", "Whisk(e)y"],
                level: 1,
                volume: "4 cl",
                items: [],
            },
            {
                name: ["Irské whiskey", "Irish whiskey"],
                level: 2,
                items: [
                    {
                        name: ["Jameson"],
                        price: ["69"],
                    },
                    {
                        name: ["Jameson Black Barrel"],
                        price: ["109"],
                    },
                    {
                        name: ["Tullamore Dew"],
                        price: ["69"],
                    },
                ],
            },
            {
                name: ["Skotské whisky", "Scotch whisky"],
                level: 2,
                items: [
                    {
                        name: ["Ardberg Ten"],
                        price: ["199"],
                    },
                    {
                        name: ["Chivas Regal 12yo"],
                        price: ["119"],
                    },
                    {
                        name: ["Chivas Regal Extra 13yo"],
                        price: ["149"],
                    },
                    {
                        name: ["Chivas Regal 18yo"],
                        price: ["229"],
                    },
                    {
                        name: ["Chivas Regal Royal Salute 21yo"],
                        price: ["399"],
                    },
                    {
                        name: ["Chivas Regal Ultis"],
                        price: ["699"],
                    },
                    {
                        name: ["Chivas Regal 25yo"],
                        price: ["999"],
                    },
                    {
                        name: ["Glenmorangie The Original"],
                        price: ["139"],
                    },
                    {
                        name: ["Monkey Shoulder"],
                        price: ["119"],
                    },
                    {
                        name: ["The Glenlivet 15 Year Old French Oak Reserve"],
                        price: ["179"],
                    },
                ],
            },
            {
                name: ["Americké whiskey", "American whiskey"],
                level: 2,
                items: [
                    {
                        name: ["Four Roses"],
                        price: ["69"],
                    },
                    {
                        name: ["Jack Daniel's No. 7"],
                        price: ["99"],
                    },
                    {
                        name: ["Wild Turkey"],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Koňaky", "Cognac"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Martell V.S."],
                        price: ["99"],
                    },
                    {
                        name: ["Martell V.S.O.P."],
                        price: ["199"],
                    },
                    {
                        name: ["Martell X.O."],
                        price: ["499"],
                    },
                    {
                        name: ["Rémy Martin V.S.O.P."],
                        price: ["199"],
                    },
                    {
                        name: ["Courvoisier X.O. Impérial"],
                        price: ["499"],
                    },
                ],
            },
            {
                name: ["Vodky", "Vodka"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Absolut Vodka"],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Absolut Vodka Citron / Mandrin / Raspberry / Vanilia",
                        ],
                        price: ["69"],
                    },
                    {
                        name: ["Skyy Vodka"],
                        price: ["69"],
                    },
                    {
                        name: ["Belvedere Vodka"],
                        price: ["139"],
                    },
                    {
                        name: ["Grey Goose Vodka"],
                        price: ["139"],
                    },
                ],
            },
            {
                name: ["Rumy", "Rum"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Bumbu Original"],
                        price: ["149"],
                    },
                    {
                        name: ["Bacardi Añejo Cuatro"],
                        price: ["149"],
                    },
                    {
                        name: ["Diplomático Reserva Exclusiva"],
                        price: ["139"],
                    },
                    {
                        name: ["Don Papa"],
                        price: ["149"],
                    },
                    {
                        name: ["Havana Club Añejo 3 Años"],
                        price: ["69"],
                    },
                    {
                        name: ["Havana Club Especial"],
                        price: ["79"],
                    },
                    {
                        name: ["Havana Club Añejo 7 Años"],
                        price: ["119"],
                    },
                    {
                        name: ["Havana Club Seleccion De Maestros"],
                        price: ["239"],
                    },
                    {
                        name: ["Havana Club Unión"],
                        price: ["999"],
                    },
                    {
                        name: ["Legendario ron"],
                        price: ["119"],
                    },
                    {
                        name: ["Millonario Aniversario Reserva 10y"],
                        price: ["189"],
                    },
                    {
                        name: ["Ron Zacapa Centenario 23"],
                        price: ["189"],
                    },
                    {
                        name: ["Ron Zacapa Centenario X.O."],
                        price: ["399"],
                    },
                    {
                        name: ["Rum Plantation O.F.T.D. Overproof"],
                        price: ["129"],
                    },
                ],
            },
            {
                name: ["Spirity", "Spirits"],
                level: 1,
                volume: "4 cl",
                items: [
                    {
                        name: ["Baileys Irish Cream"],
                        price: ["69"],
                    },
                    {
                        name: ["Becherovka"],
                        price: ["69"],
                    },
                    {
                        name: ["Fernet Stock"],
                        price: ["69"],
                    },
                    {
                        name: ["Jack Daniel's Honey"],
                        price: ["89"],
                    },
                    {
                        name: ["Jägermeister / Jägermeister Orange"],
                        price: ["69"],
                    },
                    {
                        name: ["Jägermeister Manifest"],
                        price: ["119"],
                    },
                    {
                        name: ["Lillet Blanc / Lillet Rouge"],
                        price: ["69"],
                    },
                    {
                        name: ["Metaxa 12*"],
                        price: ["139"],
                    },
                    {
                        name: ["El Jimador Blanco / Reposado"],
                        price: ["79"],
                    },
                    {
                        name: ["Patrón Tequila Blanco / Reposado"],
                        price: ["199"],
                    },
                    {
                        name: ["Tullamore Dew Honey"],
                        price: ["69"],
                    },
                    {
                        name: ["Žufánek Slivovice"],
                        price: ["139"],
                    },
                    {
                        name: ["Žufánek Hruškovice"],
                        price: ["139"],
                    },
                ],
            },
            {
                name: ["Skupiny alergenů:", "Allergen groups:"],
                level: 1,
                items: [
                    {
                        name: [
                            "1a) pšenice, 1b) žito, 1c) ječmen, 1d) oves, 2) korýši a výrobky z nich, 3) vejce a výrobky z nich, 4) ryby a výrobky z nich, 5) arašídy a výrobky z nich, 6) sojové boby a výrobky z nich, 7) mléko a výrobky z něj, 8a) mandle, 8b) lískové ořechy, 8c) vlašské ořechy, 8d) kešu ořechy, 8e) pekanové ořechy, 8f) para ořechy, 8g) pistácie, 8h) makadamie, 9) celer a výrobky z něj, 10) hořčice a výrobky z ní, 11) sezamová semena, 12) oxid siřičitý a siřičitany, 13) vlčí bob a výrobky z něj, 14) měkkýši a výrobky z nich",
                            "1a) wheat, 1b) rye, 1c) barley, 1d) oats, 2) crustaceans and products thereof, 3) eggs and products thereof, 4) fish and products thereof, 5) peanuts and products thereof, 6) soybeans and products thereof, 7) milk and products thereof, 8a) almonds, 8b) hazelnuts, 8c) walnuts, 8d) cashews, 8e) pecans, 8f) brazil nuts, 8g) pistachios, 8h) macadamia nuts, 9) celery and products thereof, 10) mustard and products thereof, 11) sesame seeds, 12) sulphur dioxide and sulphites, 13) lupin and products thereof, 14) molluscs and products thereof",
                        ],
                    },
                ],
            },
        ],
    },
    /* {
        category: ["Nápojový list", "Drink menu"],
        groups: [
            {
                name: ["Nápoje", "Drinks"],
                items: [
                    {
                        name: ["Bezinková limonáda", "Elderflower Lemonade"],
                        price: ["79"],
                    },
                    { name: ["Citronová limonáda", "Lemonade"], price: ["79"] },
                    {
                        name: ["Zázvorová limonáda", "Ginger Lemonade"],
                        price: ["79"],
                    },
                    {
                        name: ["Okurková limonáda", "Cucumber Lemonade"],
                        price: ["89"],
                    },
                    {
                        name: ["Americká limonáda", "American Lemonade"],
                        price: ["89"],
                    },
                    {
                        name: ["Pomerančový fresh juice", "Fresh Orange Juice"],
                        price: ["99"],
                    },
                    {
                        name: ["Jablečný fresh juice", "Fresh Apple Juice"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Grapefruitový fresh juice",
                            "Fresh Grapefruit Juice",
                        ],
                        price: ["99"],
                    },
                    {
                        name: ["Jahodové smoothie", "Strawberry Smoothie"],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Banánové smoothie s pomerančem",
                            "Banana Smoothie with Orange",
                        ],
                        price: ["99"],
                    },
                    {
                        name: [
                            "Smoothie z lesního ovoce",
                            "Forest Fruit Smoothie",
                        ],
                        price: ["99"],
                    },
                ],
            },
            {
                name: ["Vody", "Water"],
                items: [
                    {
                        name: ["Mattoni perlivá", "Mattoni Sparkling"],
                        price: ["49"],
                    },
                    {
                        name: [
                            "Mattoni jemně perlivá",
                            "Mattoni Slightly Sparking",
                        ],
                        price: ["49"],
                    },
                    {
                        name: ["Mattoni neperlivá", "Matonni Still"],
                        price: ["49"],
                    },
                    {
                        name: [
                            "Roemerquelle perlivá",
                            "Roemerquelle Sparkling",
                        ],
                        price: ["69 / 99"],
                    },
                    {
                        name: ["Roemerquelle neperlivá", "Roemerquelle Still"],
                        price: ["69 / 99"],
                    },
                    {
                        name: [
                            "Roemerquelle lemongrass",
                            "Roemerquelle Lemongrass",
                        ],
                        price: ["79"],
                    },
                    {
                        name: [
                            "Karafa filtrované vody perlivá / neperlivá",
                            "Carafe of filtered water sparkling / still",
                        ],
                        subtitle: [
                            "s čerstvou mátou a citrónem",
                            "with Fresh Mint and Lemon",
                        ],
                        price: ["39 / 59"],
                    },
                ],
            },
            {
                name: ["Džusy", "Fruit Juice"],
                items: [
                    {
                        name: ["Cappy"],
                        subtitle: [
                            "pomeranč, jablko, multivitamin, ananas, jahoda, černý rybíz, meruňka, hruška, grep",
                            "Orange, Apple, Multivitamin, Pineapple, Strawberry, Black Currant, Apricot, Pear, Grapefruit",
                        ],
                        price: ["69"],
                    },
                ],
            },
            {
                name: ["Nealkoholické nápoje", "Soft Drinks"],
                items: [
                    { name: ["Coca-Cola"], price: ["69"] },
                    {
                        name: ["Coca-Cola Zero", "Coca-Cola Zero"],
                        price: ["69"],
                    },
                    {
                        name: ["Coca-Cola ochucená", "Flavoured Coca-Cola"],
                        subtitle: [
                            "vanilla, cherry, passion fruit",
                            "Vanilla, Cherry, Passion Fruit",
                        ],
                        price: ["69"],
                    },
                    { name: ["Sprite, Fanta"], price: ["69"] },
                    {
                        name: [
                            "Kinley Tonic Water, Kinley Ginger Ale, Kinley Bitter Rose",
                        ],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Crodino aperitivo nealko",
                            "Crodino aperitivo (Alcohol-free)",
                        ],
                        price: ["99"],
                    },
                    {
                        name: ["Ledový čaj", "Iced Tea"],
                        subtitle: ["broskev, citron", "Peach, Lemon"],
                        price: ["79"],
                    },
                    { name: ["Red Bull"], price: ["79"] },
                    {
                        name: ["Fever-Tree Premium Indian Tonic Water"],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Pivo", "Beer"],
                items: [
                    {
                        name: [
                            "Pilsner Urquell čepovaný",
                            "Pilsner Urquell (draught)",
                        ],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Radegast Birell lahvový",
                            "Radegast Birell (bottled)",
                        ],
                        price: ["49"],
                    },
                    {
                        name: [
                            "Stella Artois ležák",
                            "Stella Artois (bottled)",
                        ],
                        price: ["59"],
                    },
                    {
                        name: ["Apple Cider lahvový", "Apple Cider (bottled)"],
                        price: ["59"],
                    },
                    {
                        name: ["Corona lahvová", "Corona (bottled)"],
                        price: ["89"],
                    },
                    {
                        name: [
                            "Elektrárna speciál čepovaný",
                            "Elektrárna Speciál draft",
                        ],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Káva", "Coffee"],
                items: [
                    {
                        name: ["Espresso", "Espresso"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso speciál", "Espresso of the Day"],
                        subtitle: ["(dle denní nabídky)", null],
                        price: ["69"],
                    },
                    {
                        name: ["Espresso ristretto", "Espresso Ristretto"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso lungo", "Espresso Lungo"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Espresso doppio", "Espresso Doppio"],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Espresso tonic", "Espresso Tonic"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Espresso macchiato", "Espresso Macchiato"],
                        subtitle: [""],
                        price: ["65"],
                    },
                    {
                        name: ["Cappuccino", "Cappuccino"],
                        subtitle: [""],
                        price: ["79"],
                    },
                    {
                        name: ["Cappuccino doppio", "Cappuccino Doppio"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: ["Flat white", "Flat White"],
                        subtitle: [""],
                        price: ["95"],
                    },
                    {
                        name: [
                            "Caffè latte macchiato",
                            "Caffè Latte Macchiato",
                        ],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Caffè latte", "Caffè Latte"],
                        subtitle: [""],
                        price: ["85"],
                    },
                    {
                        name: ["Caffè latte jumbo", "Caffè Latte Jumbo"],
                        subtitle: [""],
                        price: ["109"],
                    },
                    {
                        name: ["Frappuccino", "Frappuccino"],
                        subtitle: [""],
                        price: ["89"],
                    },
                    {
                        name: ["Caffè gelato", "Caffè Gelato"],
                        subtitle: [
                            "(se zmrzlinou a šlehačkou)",
                            "(with Ice Cream and Whipped Cream)",
                        ],
                        price: ["109"],
                    },
                    {
                        name: ["Caffè bombardino", "Caffè Bombardino"],
                        subtitle: [""],
                        price: ["99"],
                    },
                    {
                        name: ["Irish Coffee", "Caffè Irlandese"],
                        subtitle: [
                            "(s whiskey a šlehačkou)",
                            "(with Whiskey and Cream)",
                        ],
                        price: ["109"],
                    },
                    {
                        name: [
                            "Příchuť do kávy dle nabídky",
                            "Coffee Flavour of the Day",
                        ],
                        price: ["10"],
                    },
                    {
                        name: [
                            "Všechny kávy mohou být připraveny bezkofeinové a za příplatek 20,- Kč s bezlaktózovým mlékem.",
                            "All coffees can be prepared decaffeinated for an additional fee of 20 CZK with lactose-free milk.",
                        ],
                    },
                ],
            },
            {
                name: ["Čaje", "Tea"],
                items: [
                    {
                        name: [
                            "Z čerstvé máty s medem",
                            "Fresh Mint Tea with Honey",
                        ],
                        subtitle: [""],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Z čerstvého zázvoru s medem",
                            "Fresh Ginger Tea with Honey",
                        ],
                        subtitle: [""],
                        price: ["69"],
                    },
                    {
                        name: [
                            "Sypaný čaj Tea Forte s medem",
                            "Tea Forte Loose Leaf Tea with honey",
                        ],
                        subtitle: [""],
                        price: ["79"],
                    },
                ],
            },
            {
                name: ["Teplé nápoje", "Hot Drinks"],
                items: [
                    {
                        name: ["Horká čokoláda", "Hot Chocolate"],
                        price: ["99"],
                    },
                    { name: ["Svařené víno", "Mulled Wine"], price: ["79"] },
                    {
                        name: [
                            "Bombardino se šlehačkou",
                            "Bombardino with Whipped Cream",
                        ],
                        price: ["89"],
                    },
                ],
            },
            {
                name: ["Italské spirity", "Liquors/Bitters"],
                items: [
                    { name: ["Aperol Aperitivo"], price: ["69"] },
                    { name: ["Amaretto Disaronno Originale  "], price: ["79"] },
                    { name: ["Amaro Averna"], price: ["79"] },
                    { name: ["Amaro Ramazzotti"], price: ["79"] },
                    { name: ["Campari Bitter"], price: ["79"] },
                    { name: ["Frangelico Liqueur"], price: ["79"] },
                    { name: ["Grappa Fior di Vite"], price: ["89"] },
                    { name: ["Galliano"], price: ["89"] },
                    {
                        name: ["Italicus 	Rosolio di Bergamotto"],
                        price: ["129"],
                    },
                    { name: ["Limoncello Walcher"], price: ["79"] },
                    { name: ["Luxardo Maraschino Originale"], price: ["79"] },
                ],
            },
            {
                name: ["Vermuty", "Vermouth"],
                items: [
                    // { name: ["Lillet"], price: ["69"] },
                    { name: ["Martini Extra Dry"], price: ["89"] },
                    { name: ["Martini Bianco"], price: ["89"] },
                    { name: ["Martini Rosato"], price: ["89"] },
                    { name: ["Martini Rosso"], price: ["89"] },
                ],
            },
            // {
            //     name: ["Likéry/bittery", "Liquors/Bitters"],
            //     items: [
            //         { name: ["Campari Bitter"], price: ["69"] },
            //         { name: ["Jägermeister"], price: ["69"] },
            //         { name: ["Amaretto Disaronno Originale"], price: ["69"] },
            //         { name: ["Porto Ruby Sandeman"], price: ["69"] },
            //         { name: ["Jack Daniel’s Honey"], price: ["79"] },
            //         { name: ["Becherovka"], price: ["59"] },
            //         { name: ["Fernet Stock"], price: ["59"] },
            //         { name: ["Baileys Irish Cream"], price: ["59"] },
            //     ]
            // },
            {
                name: ["Giny", "Gin"],
                items: [
                    { name: ["Beefeater London Dry Gin"], price: ["69"] },
                    {
                        name: [
                            "Beefeater Pink Strawberry / Peach & Raspberry / Blood Orange",
                        ],
                        price: ["69"],
                    },
                    { name: ["Bombay Sapphire Dry Gin"], price: ["89"] },
                    {
                        name: [
                            "Citadelle Original / Rouge / Jardin d’Été / Vive Le Cornichon",
                        ],
                        price: ["99"],
                    },
                    { name: ["Gin Sul"], price: ["199"] },
                    { name: ["Hendrick's Gin"], price: ["119"] },
                    { name: ["Malfy Gin Originale"], price: ["119"] },
                    { name: ["Malfy Gin Rosa"], price: ["119"] },
                    { name: ["Monkey 47"], price: ["199"] },

                    { name: ["Plymouth Gin"], price: ["99"] },
                    { name: ["Tanqueray London Dry Gin"], price: ["99"] },
                ],
            },
            {
                name: ["Whisk(e)y"],
                items: [],
            },
            {
                name: ["Irské whiskey", "Irish Whiskey"],
                level: 2,
                items: [
                    { name: ["Jameson"], price: ["69"] },
                    { name: ["Tullamore Dew"], price: ["69"] },
                    { name: ["Jameson Black Barrel"], price: ["109"] },
                ],
            },
            {
                name: ["Skotské whisky", "Scottish Whisky"],
                level: 2,
                items: [
                    { name: ["Ardberg Ten"], price: ["199"] },
                    { name: ["Chivas Regal 12yo"], price: ["119"] },
                    { name: ["Chivas Regal Extra 13yo"], price: ["149"] },
                    { name: ["Chivas Regal 18yo"], price: ["229"] },
                    {
                        name: ["Chivas Regal Royal Salute 21yo"],
                        price: ["399"],
                    },
                    { name: ["Chivas Regal Ultis"], price: ["699"] },
                    { name: ["Chivas Regal 25yo"], price: ["999"] },
                    { name: ["Glenmorangie The Original"], price: ["139"] },
                    { name: ["Monkey Shoulder"], price: ["119"] },
                    { name: ["The Glenlivet"], price: ["179"] },
                ],
            },
            {
                name: ["Americké whiskey", "American Whiskey"],
                level: 2,
                items: [
                    { name: ["Four Roses"], price: ["69"] },
                    { name: ["Jack Daniel's No. 7"], price: ["99"] },
                    { name: ["Wild Turkey"], price: ["99"] },
                ],
            },
            // {
            //     name: ["Bourbony", "Bourbon"],
            //     level: 1,
            //     items: [
            //         { name: ["Wild Turkey"], price: ["69"] },
            //         { name: ["Four Roses"], price: ["69"] },
            //     ]
            // },
            {
                name: ["Koňaky", "Cognac"],
                level: 1,
                items: [
                    { name: ["Martell V.S."], price: ["99"] },
                    { name: ["Martell V.S.O.P"], price: ["199"] },
                    { name: ["Martell X.O"], price: ["499"] },
                    { name: ["Rémy Martin V.S.O.P."], price: ["199"] },
                    { name: ["Courvoisier X.O. Impérial"], price: ["499"] },
                ],
            },
            {
                name: ["Vodky", "Vodka"],
                level: 1,
                items: [
                    { name: ["Absolut vodka"], price: ["69"] },
                    {
                        name: ["Absolut Citron/Mandarin/Raspberry/Vanilia"],
                        price: ["69"],
                    },
                    { name: ["Skyy vodka"], price: ["69"] },
                    { name: ["Belvedere Vodka"], price: ["139"] },
                    { name: ["Grey Goose"], price: ["139"] },
                ],
            },
            {
                name: ["Rumy", "Rum"],
                level: 1,
                items: [
                    { name: ["Bumbu Original"], price: ["149"] },
                    { name: ["Diplomático Reserva Exclusiva"], price: ["139"] },
                    { name: ["Don Papa"], price: ["149"] },
                    { name: ["Havana Club Añejo 3 Años"], price: ["69"] },
                    { name: ["Havana Club Especial"], price: [" 79"] },
                    { name: ["Havana Club Añejo 7 Años"], price: ["119"] },

                    {
                        name: ["Havana Club Seleccion De Maestros "],
                        price: ["239"],
                    },
                    { name: ["Havana Club Unión "], price: ["999"] },
                    { name: ["Legendario Ron"], price: ["119"] },

                    {
                        name: ["Millonario Aniversario Reserva 10y"],
                        price: ["189"],
                    },
                    { name: ["Ron Zacapa Centenario 23"], price: ["189"] },
                    { name: ["Ron Zacapa Centenario X.O."], price: ["399"] },

                    {
                        name: ["Rum Plantation O.F.T.D. Overproof"],
                        price: ["129"],
                    },
                ],
            },
            {
                name: ["Ostatní spirity", "Other Spirits"],
                level: 1,
                items: [
                    { name: ["Baileys Irish Cream"], price: ["69"] },
                    { name: ["Becherovka"], price: ["69"] },
                    { name: ["Fernet Stock"], price: ["69"] },
                    { name: ["Jack Daniel’s Honey"], price: ["89"] },
                    {
                        name: ["Jägermeister  / Jägermeister Orange"],
                        price: ["69"],
                    },
                    { name: ["Jägermeister Manifest"], price: ["119"] },
                    { name: ["Lillet Blanc / Lillet Rouge"], price: ["69"] },
                    { name: ["Metaxa 12*"], price: ["139"] },
                    { name: ["El Jimador Blanco / Reposado"], price: ["79"] },
                    {
                        name: ["Patrón Tequila Blanco / Reposado"],
                        price: ["199"],
                    },
                    { name: ["Tullamore Dew	Honey"], price: ["69"] },
                    { name: ["Slivovice Žufánek"], price: ["139"] },
                    { name: ["Hruškovice Žufánek"], price: ["139"] },
                ],
            },
        ],
    }, */
    {
        category: ["Vinný list", "Wine List"],
        groups: [
            {
                name: [
                    "Moravská vína: Filip Mlýnek (Dolní Dunajovice)",
                    "Moravian wines: Filip Mlýnek (Dolní Dunajovice)",
                ],
            },
            {
                name: ["Bílá vína", "White Wines"],
                level: 2,
                priceLabel: ["0,15l / 0,75l", "0.15l / 0.75l"],
                items: [
                    { name: ["PÁLAVA, výběr z hroznů, polosladké nebo suché, 0,75l", "PÁLAVA, selection of grapes, semi-sweet or dry, 0.75l"], price: ["120 / 490"] },
                    { name: ["RÝNSKÝ RYZLINK, výběr z hroznů, suché, 0,75l", "RHINE RIESLING, selection of grapes, dry, 0.75l"], price: ["120 / 490"] },
                    { name: ["VLAŠSKÝ RYZLINK, pozdní sběr, suché nebo polosuché, 0,75l", "WELSCHRIESLING, late harvest, dry or semi-dry, 0.75l"], price: ["120 / 490"] },
                    { name: ["VELTLÍNSKÉ ZELENÉ, pozdní sběr, suché, 0,75l", "GRÜNER VELTLINER, late harvest, dry, 0.75l"], price: ["120 / 490"] },
                    { name: ["SAPHIRA, pozdní sběr, suché, 0,75l", "SAPHIRA, late harvest, dry, 0.75l"], price: ["120 / 490"] },
                ],
            },
            {
                name: ["Červená vína", "Red Wines"],
                level: 2,
                priceLabel: ["0,15l / 0,75l", "0.15l / 0.75l"],
                items: [
                    { name: ["MERLOT, výběr z hroznů, suché, 0,75l", "MERLOT, selection of grapes, dry, 0.75l"], price: ["140 / 590"] },
                    { name: ["ZWEIGELTREBE, výběr z hroznů, suché, 0,75l", "ZWEIGELTREBE, selection of grapes, dry, 0.75l"], price: ["140 / 590"] },
                ],
            },

            // {
            //     name: ["Rozlévané víno", "Poured Wine"],
            //     level: 1,
            //     items: [
            //         { name: ["Dle nabídky 0,1l / 0,75l", "According to current offer 0,1l / 0,75l"], subtitle: [""], price: ["40 / 290"] },
            //     ]
            // },
            {
                name: ["Zahraniční vína", "Foreign Wines"],
            },
            {
                name: ["Bílá vína", "White Wines"],
                level: 2,
                priceLabel: ["0,15l / 0,75l", "0.15l / 0.75l"],
                items: [
                    { name: ["CAMPOGRANDE ORVIETO CLASSICO (ITA), DOC, Umbria, Antinori"], price: ["100 / 390"] },
                    { name: ["GRÜNER VELTLINER KLASSIK (AUT), Weingut Josef Fritz"], price: ["100 / 390"] },
                    { name: ["RHEIN RIESLING (GER), Rhein, J. Bäumer"], price: ["100 / 390"] },
                    { name: ["PINOT GRIGIO, DELLE VENEZIE (ITA), DOC, Veneto, Botter"], price: ["100 / 390"] },
                    { name: ["GAVI DI GAVI, DOCG (ITA), DOCG, Piemonte, Masseria dei Carmelitani"], price: ["140 / 590"] },
                ],
            },
            {
                name: ["Růžová vína", "Rosé Wines"],
                level: 2,
                priceLabel: ["0,15l / 0,75l", "0.15l / 0.75l"],
                items: [
                    {
                        name: [
                            "GIARDINO ROSÉ 2021 (ITA), Toscana IGT, Antinori, vinařství Santa Cristina",
                            "GIARDINO ROSÉ 2021 (ITA), Toscana IGT, Antinori, Santa Cristina Winery",
                        ],
                        price: ["120 / 490"],
                    },
                ],
            },
            {
                name: ["Červená vína", "Red Wines"],
                level: 2,
                priceLabel: ["0,15l / 0,75l", "0.15l / 0.75l"],
                items: [
                    {
                        name: [
                            "MONTEPULCIANO D’ABRUZZO RISERVA DOC 2020 (ITA), DOC",
                            "MONTEPULCIANO D’ABRUZZO RISERVA DOC 2020 (ITA), DOC",
                        ],
                        price: ["100 / 390"],
                    },
                    {
                        name: [
                            "RAMÓN BILBAO CRIANZA 2022 (SPA), DOCa Rioja",
                            "RAMÓN BILBAO CRIANZA 2022 (SPA), DOCa Rioja",
                        ],
                        price: ["120 / 490"],
                    },
                    {
                        name: [
                            "„BORGO DEL MANDORLO“ PRIMITIVO DI MANDURIA RISERVA (ITA), DOC",
                            "„BORGO DEL MANDORLO“ PRIMITIVO DI MANDURIA RISERVA (ITA), DOC",
                        ],
                        price: ["140 / 590"],
                    },
                    {
                        name: [
                            "ACHELO TOSCANA 2021 (ITA), DOC, Toscana, Crotona, vinařství La Braccesca",
                            "ACHELO TOSCANA 2021 (ITA), DOC, Toscana, Crotona, La Braccesca Winery",
                        ],
                        price: ["180 / 790"],
                    },
                ],
            },
            {
                name: ["Rozlévané PROSECCO", "Prosecco by the Glass"],
                level: 1,
                items: [
                    {
                        name: [
                            "Sudové, Prosecco frizzante, DOC (Treviso)",
                            "Prosecco Frizzante on Tap, DOC (Treviso)",
                        ],
                        subtitle: [""],
                        price: ["100"],
                    },
                ],
            },
            {
                name: [
                    "PROSECCO, CRÉMANT A CHAMPAGNE",
                    "PROSECCO, CRÉMANT AND CHAMPAGNE",
                ],
                level: 1,
                volume: ["0,75l", "0.75l"],
                items: [
                    {
                        name: [
                            "MONTECAMPO, FAMIGLIA ZONIN, VENETO (ITA), Prosecco Spumante Brut DOC",
                        ],
                        price: ["390"],
                    },
                    {
                        name: [
                            "“BAROCCO” Prosecco Spumante, VENETO (ITA), Prosecco Spumante, Extra Dry DOC",
                        ],
                        price: ["490"],
                    },
                    {
                        name: [
                            "DI STEFANI, VENETO (ITA), Prosecco “0.15” Millesimato Extra Dry DOC",
                        ],
                        price: ["590"],
                    },
                    {
                        name: [
                            "VAL D’OCA, VENETO (ITA), Prosecco Superiore Extra Dry Millesimato, DOCG",
                        ],
                        price: ["590"],
                    },
                    {
                        name: [
                            "ASOLO, MONTELVINI, VENETO (ITA), Prosecco Superiore, Extra Brut DOCG",
                        ],
                        price: ["590"],
                    },
                    {
                        name: [
                            "ROSÉ MONTELVINI, VENETO (ITA), Prosecco, Rosé Brut Millesimato, DOC",
                        ],
                        price: ["590"],
                    },
                    {
                        name: ["CRÉMANT DE LOIRE (FRA), Brut AOC"],
                        price: ["590"],
                    },
                    {
                        name: [
                            "G. H. MUMM CORDON ROUGE (FRA), Champagne, Brut",
                        ],
                        price: ["2390"],
                    },
                ],
            },
        ],
    },
    {
        // category: ["Cocktail menu", "Cocktail Menu"],
        // groups: [
        //     {
        //         name: [""],
        //         level: 1,
        //         items: [
        //             { name: ["ROMA"], subtitle: ["Chivas Regal XII / Frangelico / Bitters", "Chivas Regal XII / Frangelico / Bitters"], price: ["129"] },
        //             // { name: ["MODENA"], subtitle: ["Prosecco / Lillet / Galliano / ostružina / citron", "Prosecco / Lillet / Galliano / Blackberry / Lemon"], price: ["129"] },
        //             { name: ["MILANO"], subtitle: ["Campari / Martini Rosso / Beefeater Gin / pomeranč", "Campari / Martini Rosso / Beefeater Gin / Orange"], price: ["129"] },
        //             { name: ["TORINO"], subtitle: ["Martini Rosato / Malfy Gin Rosa / Campari / soda", "Martini Rosato / Malfy Gin Rosa / Campari / Soda"], price: ["129"] },
        //             { name: ["VENEZIA"], subtitle: ["Aperol / Hendrick’s Gin / broskev / prosecco", "Aperol / Hendrick's Gin / Peach / Prosecco"], price: ["129"] },
        //             // { name: ["VICENZA"], subtitle: ["Havana Club Añejo 3 Años / jahoda / citron", "Havana Club Añejo 3 Años / Strawberry / Lemon"], price: ["129"] },
        //             { name: ["LIVIGNO"], subtitle: ["Jägermeister Manifest / Wild Turkey / Martini Bianco", "Jägermeister Manifest / Wild Turkey / Martini Bianc"], price: ["129"] },
        //             { name: ["NAPOLI"], subtitle: ["Havana Club Añejo 3 Años / mango / marakuja / citrus / soda", "Havana Club Añejo 3 Años / Mango / Passion Fruit / Citrus / Soda"], price: ["129"] },
        //             { name: ["PALERMO"], subtitle: ["Averna Amaro / Havana Club Añejo 3 Años / ananas / citrus", "Averna Amaro / Havana Club Añejo 3 Años / Pineapple / Citrus"], price: ["129"] },
        //             { name: ["VERONA"], subtitle: ["Skyy Vodka / Luxardo Maraschino / aronie / citrus / soda", "Skyy Vodka / Luxardo Maraschino / Aronia / Citrus / Soda"], price: ["129"] },
        //             { name: ["FIRENZE"], subtitle: ["Galliano / Skyy Vodka / espresso", "Galliano / Skyy Vodka / Espresso"], price: ["129"] },
        //             { name: ["BARI"], subtitle: ["Amaretto Disaronno / Olmeca tequila Blanco / citrus", "Amaretto Disaronno / Olmeca tequila Blanco / citrus"], price: ["129"] },
        //             // { name: ["CATANIA"], subtitle: ["Beefeater Gin / Triple sec / grapefruit / citron", "Beefeater Gin / Triple sec / Grapefruit / Lemon"], price: ["129"] },

        //         ]
        //     },
        //     {
        //         name: ["Letní speciály", "Summer Specials"],
        //         level: 1,
        //         items: [
        //             // { name: ["Mango-maracuja limonáda", "Mango & Passion Fruit Lemonade"], price: ["69"] },
        //             // { name: ["Borůvková limonáda", "Blueberry Lemonade"], price: ["69"] },
        //             { name: ["Šípková limonáda", "Blueberry Lemonade"], price: ["69"] },
        //             { name: ["Hrušková limonáda", "Blueberry Lemonade"], price: ["69"] },
        //             { name: ["Čajová infuze", "Blueberry Lemonade"], subtitle: "Bylinný čaj infuzovaný rakytníkem nebo šípkem", price: ["69"] },
        //             { name: ["Cafe New One punč", "Blueberry Lemonade"], price: ["79"] },
        //             { name: ["Horká čokoláda s marshmallows", "Blueberry Lemonade"], price: ["79"] },
        //             { name: ["Dýňově/Perníkové/Skořicové", "Blueberry Lemonade"], price: ["89"] },
        //             { name: ["Bailey's cofee", "Blueberry Lemonade"], price: ["99"] },
        //             // { name: ["Grepová limonáda", "Grapefruit Lemonade"], price: ["69"] },
        //             // { name: ["Angreštová limonáda", "Gooseberry Lemonade"], price: ["69"] },
        //             // { name: ["Levandulová limonáda", "Lavender Lemonade"], price: ["69"] },
        //             // { name: ["Ledový čaj (broskev, citron)", "Iced Tea (Peach, Lemon)"], price: ["69"] },
        //         ]
        //     },
        //     {
        //         name: ["Kávové letní speciály", "Coffee Summer Specials"],
        //         level: 2,
        //         items: [
        //             { name: ["Matcha crème Frappuccino (vanilka, kokosové mléko)", "Matcha crème Frappuccino (Vanilla, Coconut Milk)"], price: ["99"] },
        //             { name: ["Pistáciové Iced latte", "Pistachio Iced Latte"], price: ["89"] },
        //             { name: ["Karamelové Iced cappuccino", "Caramel Iced Cappuccino"], price: ["79"] },
        //         ]
        //     },
        //     {
        //         name: ["Signature", "Signature"],
        //         level: 2,
        //         items: [
        //             // { name: ["TOUCH THE WORLD"], subtitle: ["Jägermeister Manifest / Metaxa 12* / espresso / limeta", "Jägermeister Manifest / Metaxa 12* / Espresso / Lime"], price: ["149"] }
        //             { name: ["ROSE DREAM"], subtitle: ["Metaxa 12* / Rose lemonade / cascara / limeta / orange bitters", "Metaxa 12* / Rose lemonade / cascara / limeta / orange bitters"], price: ["149"] },
        //             { name: ["CHRISTMAS FIZZ"], subtitle: ["Gin / brusinka / prosecco", "MGin / brusinka / prosecco"], price: ["129"] },
        //         ]
        //     },
        //     {
        //         name: ["NON-ALCO"],
        //         level: 2,
        //         items: [
        //             { name: ["RIMINI"], subtitle: ["Crodino / pomeranč / soda", "Crodino / Orange / Soda"], price: ["89"] },
        //             { name: ["BERGAMO"], subtitle: ["Ananas / bezinka / citrus / soda", "Pineapple / Elderberry / Citrus / Soda"], price: ["89"] },
        //         ]
        //     },
        // ]
        category: ["Cocktail menu", "Cocktail Menu"],
        groups: [
            {
                name: [""],
                level: 1,
                items: [
                    { name: ["DOLCE PALOMA"], subtitle: ["Malfy Gin Rosa / Italicus / Grapefruit / Citron / Oliva / Soda", "Malfy Gin Rosa / Italicus / Grapefruit / Lemon / Olive / Soda"], price: ["169"] },
                    { name: ["WHITE LOTUS"], subtitle: ["Citadelle Jardin d’Été / Sencha / Lychee / Grapefruit / Limeta", "Citadelle Jardin d’Été / Sencha / Lychee / Grapefruit / Lime"], price: ["169"] },
                    { name: ["SOLE E MARE"], subtitle: ["Havana Club 7 Años / Amaretto Disaronno / Meruňky / Pomeranč", "Havana Club 7 Años / Amaretto Disaronno / Apricots / Orange"], price: ["169"] },
                    { name: ["TONALE"], subtitle: ["Zacapa 23 / Lillet Rouge / Frangelico / Tonic / Limeta", "Zacapa 23 / Lillet Rouge / Frangelico / Tonic / Lime"], allergens: ["12"], price: ["169"] },
                    { name: ["GIULIA"], subtitle: ["Johnnie Walker Black Label / Luxardo Maraschino / Jasmín / Maliny", "Johnnie Walker Black Label / Luxardo Maraschino / Jasmine / Raspberries"], price: ["169"] },
                    { name: ["FLORA NEGRONI"], subtitle: ["Malfy Gin Originale / Italicus / Campari / Květ bezu", "Malfy Gin Originale / Italicus / Campari / Elderflower"], price: ["169"] },
                    { name: ["TOSCANA FIZZ"], subtitle: ["Bombay Sapphire / Martini Bianco / Levandule / Citron / Soda", "Bombay Sapphire / Martini Bianco / Lavender / Lemon / Soda"], price: ["169"] },
                    { name: ["ROYAL MARTINI"], subtitle: ["Absolut Vanilia / Martini Rosato / Ostružiny / Limeta", "Absolut Vanilia / Martini Rosato / Blackberries / Lime"], price: ["169"] },
                    { name: ["NUEVA"], subtitle: ["Patrón Reposado / Martini Fiero / Espresso / Grapefruit / Limeta", "Patrón Reposado / Martini Fiero / Espresso / Grapefruit / Lime"], price: ["169"] },
                    { name: ["VESPA"], subtitle: ["Monkey Shoulder / Banán / Kokosové mléko", "Monkey Shoulder / Banana / Coconut Milk"], allergens: ["6"], price: ["169"] },
                    { name: ["BERRY VANILLY MARGARITA"], subtitle: ["El Jimador / Jack Daniel's Blackberry / Jahody / Vanilka / Limeta", "El Jimador / Jack Daniel's Blackberry / Strawberries / Vanilla / Lime"], price: ["169"] },
                    { name: ["PASSION DAIQUIRI"], subtitle: ["Malibu / Mango / Maracuja / Limeta", "Malibu / Mango / Passion Fruit / Lime"], price: ["169"] },
                ],
            },
            {
                name: ["NON-ALCO"],
                level: 1,
                items: [
                    {
                        name: ["ORANGE ESPRESSO APERITIVO"],
                        subtitle: [
                            "Crodino Rosso / Espresso / Pomeranč",
                            "Crodino Rosso / Espresso / Orange",
                        ],
                        price: ["139"],
                    },
                    {
                        name: ["L´AMOUR"],
                        subtitle: [
                            "Tanqueray 0,0% / Martini Floreale / Tonic / Meruňky / Grapefruit / Máta",
                            "Tanqueray 0.0% / Martini Floreale / Tonic / Apricots / Grapefruit / Mint",
                        ],
                        price: ["159"],
                    },
                    {
                        name: ["OLIVELLO FIZZ"],
                        subtitle: [
                            "Sober Spirits R 0.0% / Rakytník / Pomeranč / Limeta / Soda",
                            "Sober Spirits R 0.0% / Sea Buckthorn / Orange / Lime / Soda",
                        ],
                        price: ["159"],
                    },
                    {
                        name: ["ARANCIA SPRITZ"],
                        subtitle: [
                            "Ramazzotti Aperitivo 0,0% / Montelvini 0% / Pomeranč / Soda",
                            "Ramazzotti Aperitivo 0.0% / Montelvini 0% / Orange / Soda",
                        ],
                        allergens: ["12"],
                        price: ["159"],
                    },
                    {
                        name: ["STRAWBERRY SBAGLIATO"],
                        subtitle: [
                            "Martini Vibrante / Montelvini 0% / Crodino Rosso / Jahoda / Rozmarýn",
                            "Martini Vibrante / Montelvini 0% / Crodino Rosso / Strawberry / Rosemary",
                        ],
                        allergens: ["12"],
                        price: ["159"],
                    },
                    {
                        name: ["RASPBERRY G&T"],
                        subtitle: [
                            "Beefeater Gin 0.0% / Tonic / Maliny / Máta",
                            "Beefeater Gin 0.0% / Tonic / Raspberries / Mint",
                        ],
                        price: ["159"],
                    },
                    {
                        name: ["PROHIBITION LEMONADE"],
                        subtitle: [
                            "Sober Spirits W 0.0% / Martini Vibrante / Citron / Cukr / Soda",
                            "Sober Spirits W 0.0% / Martini Vibrante / Lemon / Sugar / Soda",
                        ],
                        price: ["159"],
                    },
                ],
            },
            {
                name: ["SIGNATURE SPRITZ"],
                level: 1,
                items: [
                    {
                        name: ["MANGO SPRITZ"],
                        subtitle: [
                            "Martini Fiero / Mango / Prosecco / Soda",
                            "Martini Fiero / Mango / Prosecco / Soda",
                        ],
                        allergens: ["12"],
                        price: ["159"],
                    },
                    {
                        name: ["PORNSTAR SPRITZ"],
                        subtitle: [
                            "Absolut Vanilia / Manifest / Marakuja / Mango / Prosecco / Limeta",
                            "Absolut Vanilia / Manifest / Passion Fruit / Mango / Prosecco / Lime",
                        ],
                        allergens: ["12"],
                        price: ["159"],
                    },
                    {
                        name: ["LECLERC SPRITZ"],
                        subtitle: [
                            "Chivas Regal XII / Prosecco / Květ bezu / Limeta",
                            "Chivas Regal XII / Prosecco / Elderflower / Lime",
                        ],
                        allergens: ["12"],
                        price: ["159"],
                    },
                    {
                        name: ["EXCLUSIVA SPRITZ"],
                        subtitle: [
                            "Diplomático Reserva Exclusiva / Mango / Marakuja / Limeta / Soda",
                            "Diplomático Reserva Exclusiva / Mango / Passion Fruit / Lime / Soda",
                        ],
                        price: ["159"],
                    },
                    {
                        name: ["NEGRONI SBAGLIATO"],
                        subtitle: [
                            "Campari / Martini Rosso / Prosecco",
                            "Campari / Martini Rosso / Prosecco",
                        ],
                        allergens: ["12"],
                        price: ["139"],
                    },
                    {
                        name: [
                            "APEROL SPRITZ / MARTINI SPRITZ / CAMPARI SPRITZ / LIMONCELLO SPRITZ",
                        ],
                        allergens: ["12"],
                        price: ["139"],
                    },
                ],
            },
            {
                name: ["NEGRONI SELECTION"],
                level: 1,
                items: [
                    {
                        name: ["CLASSICO"],
                        subtitle: [
                            "Malfy Gin Originale / Campari / Martini Rosso",
                            "Malfy Gin Originale / Campari / Martini Rosso",
                        ],
                        price: ["169"],
                    },
                    {
                        name: ["BIANCO"],
                        subtitle: [
                            "Malfy Gin Originale / Martini Bianco / Italicus",
                            "Malfy Gin Originale / Martini Bianco / Italicus",
                        ],
                        price: ["169"],
                    },
                    {
                        name: ["ROSATO"],
                        subtitle: [
                            "Malfy Gin Rosa / Campari / Martini Rosato / Ibišek",
                            "Malfy Gin Rosa / Campari / Martini Rosato / Hibiscus",
                        ],
                        price: ["169"],
                    },
                    {
                        name: ["SBAGLIATO (12)"],
                        subtitle: [
                            "Campari / Martini Rosso / Prosecco",
                            "Campari / Martini Rosso / Prosecco",
                        ],
                        price: ["149"],
                    },
                ],
            },
            {
                name: ["G & T SELECTION"],
                level: 2,
                items: [
                    { name: ["Gin Mare / Fever-Tree Tonic / Oliva / Rozmarýn / Citron", "Gin Mare / Fever-Tree Tonic / Olive / Rosemary / Lemon"], price: ["209"] },
                    { name: ["Bombay Sapphire / Tonic / Limeta", "Bombay Sapphire / Tonic / Lime"], price: ["159"] },
                    { name: ["Malfy Gin Rosa / Tonic / Grapefruit"], price: ["159"] },
                    { name: ["Hendrick’s Gin / Tonic / Okurka", "Hendrick’s Gin / Tonic / Cucumber"], price: ["159"] },
                    { name: ["Citadelle Rouge Gin / Tonic / Ostružina / Rozmarýn", "Citadelle Rouge Gin / Tonic / Blackberry / Rosemary"], price: ["159"] },
                    { name: ["Beefeater Pink Strawberry / Tonic / Jahody", "Beefeater Pink Strawberry / Tonic / Strawberries"], price: ["159"] },
                ],
            },
            {
                name: ["Skupiny alergenů:", "Allergen groups:"],
                level: 1,
                items: [
                    {
                        name: [
                            "1a) pšenice, 1b) žito, 1c) ječmen, 1d) oves, 2) korýši a výrobky z nich, 3) vejce a výrobky z nich, 4) ryby a výrobky z nich, 5) arašídy a výrobky z nich, 6) sojové boby a výrobky z nich, 7) mléko a výrobky z něj, 8a) mandle, 8b) lískové ořechy, 8c) vlašské ořechy, 8d) kešu ořechy, 8e) pekanové ořechy, 8f) para ořechy, 8g) pistácie, 8h) makadamie, 9) celer a výrobky z něj, 10) hořčice a výrobky z ní, 11) sezamová semena, 12) oxid siřičitý a siřičitany, 13) vlčí bob (lupina) a výrobky z něj, 14) měkkýši a výrobky z nich",
                            "1a) wheat, 1b) rye, 1c) barley, 1d) oats, 2) crustaceans and products thereof, 3) eggs and products thereof, 4) fish and products thereof, 5) peanuts and products thereof, 6) soybeans and products thereof, 7) milk and products thereof, 8a) almonds, 8b) hazelnuts, 8c) walnuts, 8d) cashews, 8e) pecans, 8f) brazil nuts, 8g) pistachios, 8h) macadamia nuts, 9) celery and products thereof, 10) mustard and products thereof, 11) sesame seeds, 12) sulphur dioxide and sulphites, 13) lupin and products thereof, 14) molluscs and products thereof",
                        ],
                    },
                ],
            },
        ],
    },
] as Array<menuType>;
